module.exports = __webpack_public_path__ + "static/img/mask-group-4.03b4d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mask-group-4.png
// module id = wQl4
// module chunks = 0